const Routes = {
  home: "/",
  supportModal: "/support-modal",
  logout: "/logout",
};

export default Routes;
